/**
 * Users
 */

// React
import React, { FunctionComponent, useContext, useEffect, useState } from 'react';
import { Link, useHistory, useParams } from 'react-router-dom';

// Context
import AuthContext from '../../authContext';

// Redux
import { connect } from 'react-redux';
import { compose } from 'redux';
import {
  getProductAction,
  getProductVariantsActions,
  getCategoriesAction,
  deleteVariantAction,
} from './actions';
import { Store } from '../../redux/reducers';

// Selector
import { createStructuredSelector } from 'reselect';
import {
  makeSelectLoading,
  makeSelectError,
  makeSelectCountList,
  makeSelectProductsVariantListByProductId,
  makeSelectProductsVariantListCount,
  makeSelectProduct,
  makeSelectCategoriesList,
  makeSelectCategoryLoading,
} from './selectors';
import { makeSelectSkusInventoryList } from '../warehouses/selectors';

// Components
import Pagination from '@material-ui/lab/Pagination';
import List from './components/variantList';
import Edit from './components/edit';
import Add from './components/add';
import Details from './components/detail';
import Inventory from './components/inventory';
import CSV from './components/csv';
import Modal from '../../components/Modal';
import ReportList from '../warehouseInventory/components/reportList';
import ProductsMobile from './mobileView/product';

// UI
import {
  Card,
  CardHeader,
  CardContent,
  Typography,
  Paper,
  CircularProgress,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  Grid,
  DialogTitle,
  FormControl,
  Select,
  MenuItem,
  Box,
} from '@material-ui/core';

// Helper
import { removeEmptyValueObject, flattenObject } from '../../utils/helpers';
import handleError from '../../utils/handleError';

// Type
import { Props, SelectorPropsVariants } from './interfaces';
import Can from '../../components/Can';
import { GetInventoryFlowRequestBuilder } from 'client-sdk/src/skus/skus';
import Client from 'client-sdk/src/client';
import SkusRepository from 'client-sdk/src/Repository/skus-repository'
import { GetCardIndexRequestBuilder } from 'client-sdk/src/parcels/parcels';
import classes from './product.module.scss';
import windowSize from '../../utils/hook/useWindowResize';
import InventorySetting from '../partnerWarehouseInventory/components/InventorySetting';
import CardIndexCsv from '../partnerWarehouseInventory/components/cardIndexCsv';
import { InventoryItems } from '../warehouses/interfaces';
import CartexList from '../partnerWarehouseInventory/components/cartexList';
import RonadIcons from '../../components/iconComponent';

// Const
interface ObjectString {
  edit: string;
  detail: string;
  assign: string;
  inventory: string;
}
const translate: ObjectString = {
  edit: 'ویرایش',
  detail: 'جزیيات محصول',
  assign: 'لیست محصول',
  inventory: 'گزارش موجودی محصول',
};

const Products: FunctionComponent<Props> = (
  props: Props
): React.ReactElement => {
  const authContext = useContext(AuthContext);
  const [openSize, setOpenSize] = React.useState(false as boolean);
  const [filtersValues, setFiltersValues] = useState({
    "productId.equals": props.match.params.id,
    page: 0,
    size: 10,
  } as any);
  const urlParams = useParams();
  const [openConfirmDisable, setOpenConfirmDisable] = useState(
    false as boolean
  );
  const [openDialog, setOpenDialog] = useState(false as boolean);
  const [type, setType] = useState('edit' as string);
  const [modal, setModal] = useState("")
  const [openAdd, setopenAdd] = useState(false as boolean);
  const [id, setId] = useState(-1 as number);

  const [openSizeReport, setOpenSizeReport] = React.useState(false as boolean);

  const [reportModal, setReportModal] = useState(false as boolean);
  const [selectedItem, setSelectedItem] = useState<any>(null);
  const [reportLoading, setReportLoading] = useState(false as boolean);
  const [reportList, setReportList] = useState<any>(null);
  const [reportFilters, setReportFilters] = useState<any>({
    page: 0,
    size: 10,
  });
  const [cardIndexCsvData, setCardIndexCsvData] = useState([]);
  const [skuList, setSkuLis] = useState([]);
  const [loadingCartex, setLoadingCartex] = useState(false as boolean);
  const [cartexData, setCartexData] = useState<null | InventoryItems[]>(null);
  const [cardIndexCsvLoading, setCardIndexCsvLoading] = useState(false as boolean);
  const [reportId, setReportId] = useState(null as any);
  const [reportCsvData, setReportCsvData] = useState([]);
  const [reportCsvLoading, setReportCsvLoading] = useState(false);
  const [inventoryFilters, setInventoryFilters] = useState({
    page: 0,
    size: 10,
  } as any);
  const [isMob, setIsMob] = useState(false);
  const { width } = windowSize();
  const history = useHistory()
  const token = localStorage.getItem('token') || '';

  const handleCloseReportModal = () => {
    setReportModal(false);
    setReportList(null);
    setReportCsvData([]);
  };
  const handleChangeSizeReportList = (
    event: React.ChangeEvent<{ value: unknown }>
  ) => {
    setReportFilters({ ...reportFilters, page: 0, size: event.target.value });
    fetchReportList(reportId, { ...reportFilters, size: event.target.value });
  };

  const fetchReportCsv = async () => {
    try {
      setReportCsvLoading(true);
      const parcelId = selectedItem.id;
      const request = new GetInventoryFlowRequestBuilder()
        .id(parcelId)
        .params({ size: 10000 })
        .build();
      const client = new Client(token);
      const { data } = await client.execute(request);
      setReportCsvData(data.content);
    } catch (e) {
      handleError(e);
    } finally {
      setReportCsvLoading(false);
    }
  };
  const fetchReportList = async (id: number, args: Record<string, any>) => {
    try {
      setReportLoading(true);
      const request = new GetInventoryFlowRequestBuilder()
        .id(id)
        .params({
          ...removeEmptyValueObject(flattenObject(reportFilters)),
          ...args,
        })
        .build();
      const client = new Client(token);
      const { data } = await client.execute(request);
      setReportList(data);
    } catch (err) {
      handleError(err);
    } finally {
      setReportLoading(false);
    }
  };
  const findSelectedItem = (id: number) => {
    const findSelectSku = skuList.find(
      (el: any) => el.id === id
    )!;
    console.log(findSelectSku)
    setSelectedItem(findSelectSku);
  };

  const handleReport = (id: number) => {
    setReportModal(true);
    setReportId(id);
    fetchReportList(id);
    findSelectedItem(id);
  };

  const handleChangeReportPage = (
    _: React.ChangeEvent<unknown>,
    page: number
  ) => {
    setReportFilters({ ...reportFilters, page: page - 1 });
    fetchReportList(reportId, { ...reportFilters, page: page - 1 });
  };

  const handleGetParcelInventory = (id: number) => {
    setInventoryFilters((prevState: Record<string, any>) => ({
      ...prevState,
      'parcelId.equals': id,
    }));
    getParcelInventoryRequest({ 'parcelId.equals': id });
  };
  const getParcelInventoryRequest = (arg: Record<string, any>) => {
    props.getParcelInventoryItems({ ...inventoryFilters, ...arg });
  };

  useEffect(() => {
    if (width && width <= 480) {
      setIsMob(true);
    } else {
      setIsMob(false);
    }
  }, [width]);

  useEffect(() => {
    getProduct();
    getProductVariants();
  }, [filtersValues]);

  const getProduct = () => {
    const { page, size } = filtersValues;
    const { partnerId } = props.match.params;
    props.productDispatch({
      ...removeEmptyValueObject(filtersValues),
      partnerId: { equals: partnerId },
      id: urlParams.id,
      page,
      size,
    });
  };

  const getProductVariants = async () => {
    try {
      const response = await SkusRepository.getSkusInventory({payload: {
        pagination: {
          ...removeEmptyValueObject(filtersValues),
        }
      }})
      setSkuLis(response.data.content)
    } catch (error) {
      handleError(error)
    }
    // props.productVariantsDispatch({
    //   ...removeEmptyValueObject(filtersValues),
    //   partnerId: { equals: partnerId },
    //   id: urlParams.id,
    //   page,
    //   size,
    // });
  };

  const handleChangePage = (
    event: React.ChangeEvent<unknown>,
    page: number
  ) => {
    setFiltersValues({ ...filtersValues, page: page - 1 });
  };

  const handleCloseSelect = () => {
    setOpenSize(false);
  };

  const handleChangeSizePage = (event: React.ChangeEvent<{ value: unknown }>) => {
    setFiltersValues({ ...filtersValues, page: 0, size: event.target.value });
  };

  const handleDisableUser = async () => {
    const body = skuList.find(item => item.id === id) as any;
    await props.updateProductsDispatch({
      body: { ...body, status: 'SUSPENDED' },
      pagination: filtersValues,
      id: props.match.params.partnerId,
    });
    setOpenConfirmDisable(false);
  };

  const handleOpenConfirmDisable = (id: number) => {
    setOpenConfirmDisable(true);
    setId(id);
  };
  const handleOpen = (id: number, type: string) => {
    setType(type);
    setOpenDialog(true);
    setId(id);
  };

  const handleClose = () => {
    setOpenConfirmDisable(false);
    setOpenDialog(false);
    setopenAdd(false);
  };

  const handleOpenConfirmUpdateState = (data: { id: number; body: any }) => {
    setId(data.id);
  };

  const handleDelete = async (id: number) => {
    await props.deleteVariantDispatch({
      id,
      callback: getProductVariants
    });
  }

  const handleOpenInventorySettingModal = (id: number) => {
    findSelectedItem(id);
    // setInventoryVariantId(id);
    // setIds([id]);
    setModal("INVENTORY_SETTING")
  };

  const handleCloseCartexModal = () => {
    setModal("")
    setSelectedItem(null);
    setCardIndexCsvData([]);
  };

  const handleOpenCartexModal = (id: number) => {
    findSelectedItem(id);
    getCardIndex(id);
    setModal("CARTEX");
  };

  const getCardIndex = async (id: number) => {
    try {
      // const flat = flattenObject(filtersValues);
      setLoadingCartex(true);
      const request = new GetCardIndexRequestBuilder()
        .params({
          // ...removeEmptyValueObject(flat),
          // page: undefined,
          'skuId.equals': id,
          'status.equals': 'LOCATED',
          size: 100,
        })
        .build();
      const client = new Client(token);
      const { data } = await client.execute(request);
      setCartexData(data);
    } catch (e) {
      handleError(e);
    } finally {
      setLoadingCartex(false);
    }
  };

  const fetchCardIndexCsv = async () => {
    try {
      setCardIndexCsvLoading(true);
      // @ts-ignore
      const variantId = cartexData[0].variantId!;
      const makeRequest = new GetCardIndexRequestBuilder()
        .params({
          size: 1000,
          'skuId.equals': variantId,
          'status.equals': 'LOCATED',
        })
        .build();
      const client = new Client(token);
      const { data } = await client.execute(makeRequest);
      setCardIndexCsvData(data);
    } catch (err) {
      handleError(err);
    } finally {
      setCardIndexCsvLoading(false);
    }
  };

  return isMob ? (
    <ProductsMobile {...props} />
  ) : (
    <div className={classes.root}>
      <h2 className={classes.title}>
        <Button onClick={() => history.goBack()}>
          <RonadIcons name='chevronRight' />
        </Button>
        {`جزیيات `}
        {props.product.name.concat(' - ', props.product.id)}
      </h2>
      <Grid container spacing={1} alignItems="flex-start">
        <Grid item lg={92} xs={12}>
          <Card className={classes.card}>
            <CardContent>
              <Grid item xs={12}>
                {props.loading ? (
                  <div className={classes.loading}>
                    <CircularProgress />
                  </div>
                ) : (
                  skuList && (
                    <List
                      handleDelete={handleDelete}
                      handleReport={handleReport}
                      data={skuList}
                      openInventorySettingModal={
                        handleOpenInventorySettingModal
                      }
                      openCartexModal={handleOpenCartexModal}
                      productName={props.product.name}
                      handleOpenConfirmDisable={handleOpenConfirmDisable}
                      handleOpen={handleOpen}
                      changeStatus={handleOpenConfirmUpdateState}
                    />
                  )
                )}
              </Grid>
              <Grid
                md={12}
                container
                justifyContent="space-between"
                style={{ marginTop: '10px', padding: '10px' }}
              >
                <Grid id="showFilter" item xs={6} sm={6}>
                  {skuList && (
                    <FormControl
                      style={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                      }}
                    >
                      <div style={{ marginLeft: '10px', color: '#8a8a8a' }}>
                        {' '}
                        تعداد نمایش در هر صفحه:
                      </div>
                      <Select
                        open={openSize}
                        onClose={handleCloseSelect}
                        className={classes.showCount}
                        onOpen={() => setOpenSize(true)}
                        value={filtersValues.size}
                        onChange={handleChangeSizePage}
                      >
                        <MenuItem value={10}>10</MenuItem>
                        <MenuItem value={20}>20</MenuItem>
                        <MenuItem value={50}>50</MenuItem>
                        <MenuItem value={100}>100</MenuItem>
                      </Select>
                    </FormControl>
                  )}
                </Grid>
                <Grid container item md={6} direction="row-reverse">
                  {skuList && (
                    <Pagination
                      count={Math.ceil(
                        props.productVariantListCount / filtersValues.size
                      )}
                      color="secondary"
                      page={filtersValues.page + 1}
                      onChange={handleChangePage}
                    />
                  )}
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
      <Dialog
        fullWidth
        open={openConfirmDisable}
        onClose={handleClose}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle>
          {` آیا از غیر فعال کردن محصول با نام
          "${skuList.find(item => item.id === id)?.name}"
          اطمینان دارید؟`}
        </DialogTitle>
        <DialogActions>
          <Button
            autoFocus
            onClick={handleClose}
            variant="contained"
            color="primary"
          >
            {`خیر`}
          </Button>
          <Button
            onClick={handleDisableUser}
            variant="outlined"
            color="primary"
          >
            {`بله`}
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        fullScreen
        open={openDialog}
        onClose={handleClose}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle>
          <div>{` 
          ${translate[type]}
        "${skuList.find(item => item.id === id)?.name}"
        `}</div>
          <Button aria-label="details" size="medium" onClick={handleClose}>
            <RonadIcons name='chevronRight' size={1} />
            {`بازگشت`}
          </Button>
        </DialogTitle>
        <DialogContent>
          {type === 'edit' && (
            <Edit
              data={skuList.find(item => item.id === id)}
              partnerId={props.match.params.partnerId}
              update={body => {
                props.updateProductsDispatch({
                  body,
                  pagination: filtersValues,
                  id: props.match.params.partnerId,
                });
                handleClose();
              }}
            />
          )}

          {type === 'inventory' && (
            <Inventory
              data={skuList.find(
                product => product.id === id
              )}
            />
          )}
        </DialogContent>
      </Dialog>
      <Modal
        maxWidth="md"
        onClose={() => setModal("")}
        open={modal == "INVENTORY_SETTING"}
        title={
          <div style={{ textAlign: 'center' }}>
            <span>{`تنظیمات موجودی کالا `}</span>
          </div>
        }
        content={
          <InventorySetting
            id={selectedItem?.id}
            selectedItems={1}
            selectedItemsDetail={[selectedItem]}
            onClose={() => setModal("")}
            handleChangeInventorySetting={() => setModal("")}
          />
        }
      />
      <Modal
        maxWidth="md"
        onClose={handleCloseCartexModal}
        open={modal == "CARTEX"}
        title={
          <div style={{ textAlign: 'right' }}>
            <span>{`کارتکس کالای ${selectedItem?.productName}`}</span>
          </div>
        }
        content={
          <React.Fragment>
            <Grid container spacing={3}>
              <Grid item xs={12} sm={4}>
                <div className={classes.item}>
                  <span className={classes.label}>
                    {`نام کالا:  `}
                  </span>

                  <span>{selectedItem?.productName}</span>
                </div>
              </Grid>
              <Grid item xs={12} sm={4}>
                <div className={classes.item}>
                  <span className={classes.label}>
                    {`شناسه کلا:  `}
                  </span>
                  <span>{selectedItem?.productId}</span>
                </div>
              </Grid>

              <Grid item xs={12} sm={4}>
                <div className={classes.item}>
                  <span className={classes.label}>
                    {`کد کالا:  `}
                  </span>
                  <span>{selectedItem?.productCode}</span>
                </div>
              </Grid>

              <Grid item xs={12} sm={4}>
                <div className={classes.item}>
                  <span className={classes.label}>
                    {`شناسه تنوع:  `}
                  </span>
                  <span>{selectedItem?.id}</span>
                </div>
              </Grid>

              <Grid item xs={12} sm={4}>
                <div className={classes.item}>
                  <span className={classes.label}>
                    {`فروشنده/تامین‌کننده:  `}
                  </span>
                  <span>
                    {selectedItem?.providerName
                      ? selectedItem?.providerName
                      : selectedItem?.sellerName}
                  </span>
                </div>
              </Grid>

              <Grid item xs={12} sm={4}>
                <div className={classes.item}>
                  <span className={classes.label}>
                    {`کد فروشنده/تامین‌کننده:  `}
                  </span>
                  <span>
                    {selectedItem?.providerId
                      ? selectedItem?.providerId
                      : selectedItem?.sellerId}
                  </span>
                </div>
              </Grid>

              <Grid item xs={12}>
                {loadingCartex ? (
                  <div className={classes.loading}>
                    <CircularProgress />
                  </div>
                ) : (
                  <React.Fragment>
                    <Grid item xs={12}>
                      <div style={{ textAlign: 'left' }}>
                        <Can
                          role={authContext.user.role}
                          perform="skus:downloadCSV"
                          yes={() => (
                            <>
                              {cartexData?.length > 0 && (
                                <CardIndexCsv
                                  loading={cardIndexCsvLoading}
                                  handleCreateCSV={fetchCardIndexCsv}
                                  data={cardIndexCsvData}
                                />
                              )}
                            </>
                          )}
                        />
                      </div>
                      <Box mb={3} />
                    </Grid>
                    <CartexList data={cartexData} />
                  </React.Fragment>
                )}
              </Grid>
            </Grid>
          </React.Fragment>
        }
      />
      <Dialog
        fullScreen
        open={openAdd}
        onClose={handleClose}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle>
          <div>ایجاد محصول جدید</div>
          <Button aria-label="details" size="medium" onClick={handleClose}>
            <RonadIcons name='chevronRight' size={1} />
            {`بازگشت`}
          </Button>
        </DialogTitle>
        <DialogContent>
          <Add
            partnerId={props.match.params.partnerId}
            create={body => {
              props.createProductDispatch({
                body,
                pagination: filtersValues,
                id: props.match.params.partnerId,
              });
              handleClose();
            }}
          />
        </DialogContent>
      </Dialog>
      <Modal
        maxWidth="md"
        onClose={handleCloseReportModal}
        open={reportModal}
        title={
          <div style={{ textAlign: 'right' }}>
            <span>{`تاریخچه ورود و خروج کالای ${props.product.name}`}</span>
          </div>
        }
        content={
          <Grid container spacing={3}>
            <Grid item xs={12}>
              {reportLoading ? (
                <div className={classes.loading}>
                  <CircularProgress />
                </div>
              ) : (
                <React.Fragment>
                  <Grid item xs={12}>
                    <div style={{ textAlign: 'left' }}>
                      <Can
                        role={authContext.user.role}
                        perform="skus:downloadCSV"
                        yes={() => (
                          <CSV
                            loading={reportCsvLoading}
                            handleCreateCSV={fetchReportCsv}
                            data={reportCsvData}
                          />
                        )}
                      />
                    </div>
                    <Box mb={3} />
                  </Grid>
                  <ReportList
                    data={reportList?.content}
                    handleSelect={handleGetParcelInventory}
                  />
                </React.Fragment>
              )}
            </Grid>
            <Grid item xs={12} sm={6}>
              <FormControl
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  alignItems: 'center',
                }}
              >
                <div style={{ marginLeft: '10px', color: '#8a8a8a' }}>
                  {' '}
                  تعداد نمایش در هر صفحه:
                </div>
                <Select
                  open={openSizeReport}
                  onClose={() => setOpenSizeReport(false)}
                  onOpen={() => setOpenSizeReport(true)}
                  value={reportFilters.size}
                  onChange={handleChangeSizeReportList}
                >
                  <MenuItem value={10}>10</MenuItem>
                  <MenuItem value={20}>20</MenuItem>
                  <MenuItem value={50}>50</MenuItem>
                  <MenuItem value={100}>100</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid xs={12} sm={6} container item direction="row-reverse">
              <Pagination
                className={classes.pagination}
                count={Math.ceil(
                  reportList?.totalElements / reportFilters.size
                )}
                color="secondary"
                page={reportFilters?.page + 1}
                onChange={handleChangeReportPage}
              />
            </Grid>
          </Grid>
        }
      />
    </div>
  );
};

const mapStateToProps = createStructuredSelector<Store, SelectorPropsVariants>({
  skusInventoryList: makeSelectSkusInventoryList(),
  product: makeSelectProduct(),
  categoriesList: makeSelectCategoriesList(),
  productsVariantsList: makeSelectProductsVariantListByProductId(),
  productVariantListCount: makeSelectProductsVariantListCount(),
  count: makeSelectCountList(),
  loading: makeSelectLoading(),
  categoryLoading: makeSelectCategoryLoading(),
  error: makeSelectError(),
});

function mapDispatchToProps(dispatch: Function) {
  return {
    deleteVariantDispatch: (payload: object) => dispatch(deleteVariantAction(payload)),
    productDispatch: (payload: Object) => dispatch(getProductAction(payload)),
    categoriesDispatch: (payload: Object) =>
      dispatch(getCategoriesAction(payload)),
    productVariantsDispatch: (payload: Object) =>
      dispatch(getProductVariantsActions(payload)),
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);
export default compose(withConnect)(Products);
